var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCachOnDeliveryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_43452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3699 2.82L16.2799 0.56C15.8199 0.35 15.3299 0.25 14.8299 0.25C14.3299 0.25 13.8399 0.36 13.3799 0.56L10.6599 1.77L8.49992 2.73L6.24992 3.73C5.84992 3.91 5.47992 4.16 5.16992 4.48L13.7399 8.29C14.0799 8.44 14.4599 8.52 14.8299 8.52C15.1999 8.52 15.5799 8.44 15.9199 8.29L18.1799 7.28L20.3399 6.32L21.2099 5.94C21.0599 5.46 20.9799 4.96 20.9899 4.46C21.0099 3.9 21.1399 3.35 21.3599 2.83L21.3699 2.82Z",
    fill: "url(#paint0_linear_245_43452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.98 13.7098C23.37 13.4598 22.82 13.0998 22.35 12.6398C21.61 11.9098 21.14 10.9598 21.03 9.99977C20.98 9.65977 21 9.31977 21.1 8.98977C21.19 8.66977 21.35 8.36977 21.57 8.10977C21.74 7.90977 21.94 7.73977 22.17 7.59977C22.14 7.56977 22.12 7.53977 22.09 7.50977L21.22 7.89977L19.44 8.67977L16.64 9.92977C16.34 10.0498 16.04 10.1398 15.73 10.2198V21.5298C15.92 21.4798 16.11 21.4098 16.29 21.3298L23.42 18.1598C24.05 17.8798 24.58 17.4198 24.96 16.8498C25.27 16.3698 25.45 15.8298 25.51 15.2698C25.2 15.1598 24.91 14.9898 24.66 14.7598C24.35 14.4698 24.12 14.1098 23.99 13.7198L23.98 13.7098Z",
    fill: "url(#paint1_linear_245_43452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0299 9.93006C13.3299 10.0501 13.6299 10.1501 13.9399 10.2201V21.5301C13.7499 21.4801 13.5599 21.4101 13.3799 21.3301L6.24988 18.1601C5.61988 17.8801 5.08988 17.4201 4.70988 16.8501C4.32988 16.2701 4.12988 15.6001 4.12988 14.9101V7.00006C4.12988 6.68006 4.16988 6.37006 4.25988 6.06006L13.0199 9.94006L13.0299 9.93006Z",
    fill: "url(#paint2_linear_245_43452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28 33.4599H1.43C1.05 33.4599 0.69 33.3099 0.42 33.0399C0.15 32.7699 0 32.4099 0 32.0299V26.3299C0 25.9499 0.15 25.5899 0.42 25.3199C0.69 25.0499 1.05 24.8999 1.43 24.8999H4.28C4.66 24.8999 5.02 25.0499 5.29 25.3199C5.56 25.5899 5.71 25.9499 5.71 26.3299V32.0299C5.71 32.4099 5.56 32.7699 5.29 33.0399C5.02 33.3099 4.66 33.4599 4.28 33.4599Z",
    fill: "url(#paint3_linear_245_43452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0899 26.8399C27.0899 27.1199 27.0299 27.4099 26.8999 27.6599C26.7799 27.9199 26.5999 28.1399 26.3699 28.3199L21.5199 32.1999C20.5099 33.0099 19.2499 33.4499 17.9599 33.4499H9.97988C9.21988 33.4499 8.49988 33.1499 7.96988 32.6099C7.43988 32.0799 7.12988 31.3499 7.12988 30.5999V27.7499C7.12988 26.9899 7.42988 26.2699 7.96988 25.7399C8.49988 25.2099 9.22988 24.8999 9.97988 24.8999H17.2799C17.7099 24.8999 18.1099 25.0699 18.4099 25.3699C18.7099 25.6699 18.8799 26.0799 18.8799 26.4999C18.8799 26.9199 18.7099 27.3299 18.4099 27.6299C18.1099 27.9299 17.6999 28.0999 17.2799 28.0999H12.8299C12.5499 28.0999 12.2699 28.2099 12.0699 28.4099C11.8699 28.6099 11.7599 28.8799 11.7599 29.1699C11.7599 29.4599 11.8699 29.7299 12.0699 29.9299C12.2699 30.1299 12.5399 30.2399 12.8299 30.2399H17.2799C18.1599 30.2399 19.0199 29.9299 19.6899 29.3599C20.3699 28.7899 20.8199 27.9999 20.9699 27.1299L24.2099 25.1899C24.4999 25.0099 24.8399 24.9199 25.1799 24.9199C25.6899 24.9199 26.1699 25.1199 26.5299 25.4799C26.8899 25.8399 27.0899 26.3199 27.0899 26.8299V26.8399Z",
    fill: "url(#paint4_linear_245_43452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9901 6.04023L18.8301 7.00023L9.14014 2.45023L11.3001 1.49023L20.9801 6.04023H20.9901Z",
    fill: "url(#paint5_linear_245_43452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3598 9.42023C30.3598 8.70023 30.0998 7.99023 29.6098 7.42023C29.1198 6.85023 28.4398 6.44023 27.6798 6.27023L25.5698 5.79023C25.2698 5.72023 25.0098 5.56023 24.8198 5.34023C24.6398 5.12023 24.5398 4.86023 24.5398 4.58023C24.5398 4.25023 24.6798 3.93023 24.9398 3.70023C25.1998 3.47023 25.5398 3.33023 25.8998 3.33023H26.8198C27.1598 3.33023 27.4798 3.44023 27.7298 3.65023C27.9798 3.86023 28.1398 4.14023 28.1698 4.44023C28.1798 4.57023 28.2198 4.70023 28.2898 4.82023C28.3598 4.94023 28.4498 5.04023 28.5598 5.13023C28.6698 5.21023 28.7998 5.28023 28.9398 5.32023C29.0798 5.36023 29.2298 5.37023 29.3698 5.35023C29.5098 5.34023 29.6498 5.29023 29.7798 5.23023C29.9098 5.16023 30.0198 5.08023 30.1098 4.97023C30.1998 4.86023 30.2598 4.74023 30.2998 4.61023C30.3398 4.48023 30.3498 4.35023 30.3298 4.21023C30.2498 3.51023 29.9198 2.86023 29.3898 2.35023C28.8698 1.84023 28.1698 1.50023 27.4198 1.38023V0.990234C27.4198 0.720234 27.2998 0.470234 27.0998 0.280234C26.8998 0.0902344 26.6198 -0.00976562 26.3298 -0.00976562C26.0398 -0.00976562 25.7598 0.100234 25.5598 0.280234C25.3598 0.470234 25.2398 0.720234 25.2398 0.990234V1.39023C24.4498 1.53023 23.7298 1.91023 23.2098 2.47023C22.6898 3.03023 22.3898 3.74023 22.3698 4.48023C22.3498 5.22023 22.5998 5.94023 23.0898 6.53023C23.5798 7.12023 24.2698 7.54023 25.0498 7.72023L27.1598 8.20023C27.4498 8.27023 27.7198 8.42023 27.8998 8.64023C28.0898 8.86024 28.1898 9.13023 28.1898 9.41023C28.1898 9.74023 28.0398 10.0602 27.7898 10.2902C27.5398 10.5202 27.1898 10.6602 26.8298 10.6602H25.9098C25.5698 10.6602 25.2498 10.5502 24.9998 10.3402C24.7498 10.1302 24.5898 9.85023 24.5598 9.55023C24.5498 9.42023 24.5098 9.29023 24.4398 9.17023C24.3698 9.05023 24.2798 8.95023 24.1698 8.86023C24.0598 8.78023 23.9298 8.71023 23.7898 8.67023C23.6498 8.63023 23.4998 8.62023 23.3598 8.64023C23.2198 8.65024 23.0698 8.70023 22.9498 8.76023C22.8198 8.83023 22.7098 8.91024 22.6198 9.02024C22.5298 9.13023 22.4698 9.25023 22.4298 9.38023C22.3898 9.51023 22.3798 9.64023 22.3998 9.78023C22.4798 10.4702 22.8098 11.1202 23.3198 11.6302C23.8298 12.1402 24.5098 12.4802 25.2598 12.6202V13.0002C25.2598 13.2702 25.3698 13.5202 25.5798 13.7102C25.7798 13.9002 26.0598 14.0002 26.3498 14.0002C26.6398 14.0002 26.9198 13.8902 27.1198 13.7102C27.3198 13.5202 27.4398 13.2702 27.4398 13.0002V12.6102C28.2598 12.4802 29.0098 12.0902 29.5498 11.5102C30.0898 10.9302 30.3798 10.1902 30.3798 9.42023H30.3598Z",
    fill: "url(#paint6_linear_245_43452)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_43452",
    x1: 13.2854,
    y1: 0.25,
    x2: 13.2854,
    y2: 8.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A305D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_43452",
    x1: 22.66,
    y1: 9.74977,
    x2: 16.27,
    y2: 20.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D508E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_43452",
    x1: 5.99989,
    y1: 5,
    x2: 9.03488,
    y2: 21.5301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A305D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_245_43452",
    x1: 5.3,
    y1: 33.0999,
    x2: -5.09,
    y2: 16.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D508E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_245_43452",
    x1: 18.3199,
    y1: 24.3499,
    x2: 13.9799,
    y2: 34.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACC6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D508E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_245_43452",
    x1: 15.6701,
    y1: 4.02023,
    x2: 35.4301,
    y2: -3.36977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6496CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_245_43452",
    x1: 26.9998,
    y1: 0.000244031,
    x2: 20.2631,
    y2: 13.1076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB5E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_43452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.37,
    height: 33.46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCachOnDeliveryicon);
export default __webpack_public_path__ + "static/media/CachOnDeliveryicon.ceaf55577db9df5ac7b47272357cc7df.svg";
export { ForwardRef as ReactComponent };